import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import { Modal } from "components"
import { useSubmitHandler } from "hooks"
import { UserSubscriptionForm } from "./UserSubscriptionForm"
import { manualSubscription } from "store/actions"

export const UserSubscriptionEdit = ({ modalRef, user, onSuccess, onClose }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { loading, deleting, error } = useSelector(
    state => state.userAccounts.manualSubscription
  )

  const [modalVisible, setModalVisible] = useState(false)

  useEffect(() => {
    return () => {
      if (modalVisible) {
        dispatch(manualSubscription.cleanState())
      }
    }
  }, [modalVisible])

  const closeModal = () => {
    if (modalRef.current) {
      modalRef.current.hide()
    }
  }

  const { handleSubmit } = useSubmitHandler(
    ({ params, onSuccess: onUpdateSuccess, onError }) => {
      dispatch(
        manualSubscription.update({
          userId: user.id,
          params,
          onSuccess: onUpdateSuccess,
          onError,
        })
      )
    },
    () => {
      onSuccess && onSuccess()
      closeModal()
    }
  )

  const handleDelete = () => {
    dispatch(
      manualSubscription.remove({
        userId: user.id,
        onSuccess: () => {
          onSuccess && onSuccess()
          closeModal()
        },
      })
    )
  }

  const handleVisibleChange = visible => {
    setModalVisible(visible)

    if (!visible) {
      dispatch(manualSubscription.cleanState())
      onClose && onClose()
    }
  }

  return (
    <Modal
      ref={modalRef}
      title={t("edit_subscription")}
      onVisibleChange={handleVisibleChange}
      strapModalProp={{
        centered: true,
      }}
    >
      {user && (
        <UserSubscriptionForm
          key={user.id}
          user={user}
          loading={loading}
          deleting={deleting}
          error={error}
          onSubmit={handleSubmit}
          onDelete={handleDelete}
          onCancel={closeModal}
        />
      )}
    </Modal>
  )
}

UserSubscriptionEdit.propTypes = {
  modalRef: PropTypes.any,
  user: PropTypes.object,
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
}
